( function () {
	'use strict';

	function Filter () {
		return {
			'templateUrl'      : '/templates/components/filter/filter.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'Filter',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'model'      : '=',
				'collection' : '=',
				'onDelete'   : '&',
				'mode'       : '@',
				'inCreation' : '=',
				'index'      : '=',
				'canDelete'  : '=',
				'onEdit'     : '&',
				'onUpdate'   : '&'
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'filter', Filter );
} )( );
